// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__OpoPA"};